<div class="d-flex flex-wrap pt-3">
  <p-expandable-text
    *ngIf="notes && notes.content && notes.content.length > 0; else noContent"
    [text]="notes.content"
    [maxLines]="3"
  ></p-expandable-text>

  <ng-template #noContent>
    <p>Non renseigné</p>
  </ng-template>
</div>
